<template lang="pug">
  .b2b-table-servicios
    //- Filtros Tabla Servicios
    b2b-filters-servicios(:filter-options='options')

    ods-table(
      :data='services.tableData',
      :default-sort="{prop: 'taxIdentificationNumber', order: 'ascending'}",
      style='width: 100%',
      @sort-change='orderOnServer',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='name',
        :label='$t("projects.entity_table.name")',
        :show-overflow-tooltip='true',
        v-if='isShowNameServices',
        sortable='')
      ods-table-column(
        prop='code',
        :label='$t("projects.entity_table.code")',
        :show-overflow-tooltip='true',
        v-if='isShowCodeServices',
        sortable='')
      ods-table-column(
        prop='isSender',
        :label='$t("projects.entity_table.issuing")',
        v-if='isShowIsSenderServices',
        sortable='')
        template(slot-scope='scope')
          ods-switch(
            :disabled='!canModifyProject',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            v-model='scope.row.isSender',
            @change='updateSender(scope.row)')
      ods-table-column(
        prop='isReceiver',
        :label='$t("projects.entity_table.reception")',
        v-if='isShowIsReceiverServices',
        sortable='')
        template(slot-scope='scope')
          ods-switch(
            :disabled='!canModifyProject',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            v-model='scope.row.isReceiver',
            @change='updateReceiver(scope.row)')
      ods-table-column(
        prop='creationDateTime',
        :label='$t("projects.entity_table.creation_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowCreationDateTimeServices',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='enable',
        :label='$t("projects.entity_table.enabled")',
        v-if='isShowStatusServices',
        sortable='')
        template(slot-scope='scope')
          ods-switch(v-model='scope.row.enable',
            :disabled='!canAdminIndra',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            @change='goUpdateStatusProject(scope.row)')
      //- Ocultas por defecto
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='80')
        template(slot-scope='scope')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              :id='"tableServicios_" + scope.row.name',
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')

    ods-row.b2b-table-servicios__pagination()
      ods-col.b2b-table-servicios__pagination--left(:span='4')

        //- Paginación Tabla
      ods-col.b2b-table-servicios__pagination--right(:span='24')
        ods-pagination(
          ref='pagination',
          popper-class='b2b-pagination__dropdown',
          @size-change='handleSizeChange',
          @current-change='handleCurrentChangePagination',
          :current-page.sync='currentPage',
          :page-sizes='[20, 50, 100]',
          :page-size='20',
          layout='total, sizes, prev, pager, next, slot',
          :total='services.totalServices')

      //- Servicios Seleccionados
      transition(
        name='slide',
        mode='out-in')
        b2b-table-select-rows(
          v-if='multipleSelection.length',
          :total-select='multipleSelection.length')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersServicios from '@/views/administracion/servicios/B2bFiltersServicios'
import B2bTableMenuServicios from '@/views/administracion/servicios/B2bTableMenuServicios'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-servicios'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-servicios',
  mixins: [Utils],
  data () {
    return {
      multipleSelection: [],
      multipleSelectionIds: [],
      // Paginación
      totalResults: 0,
      currentPage: 0,
      urlService: null
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'services',
      'queryServices',
      'isShowNameServices',
      'isShowCodeServices',
      'isShowEnabledServices',
      'isShowIsSenderServices',
      'isShowIsReceiverServices',
      'isShowCreationDateTimeServices',
      'isShowStatusServices',
      // Permisos
      'canAdminIndra',
      'canModifyProject',
      'primaryColor',
      'urlIn'
    ])
  },

  components: {
    B2bFiltersServicios,
    B2bTableMenuServicios,
    B2bTableSelectRows
  },

  methods: {
    ...mapActions([
      'getServices',
      'queryServicesState',
      'selectService',
      'updateStatusProject',
      'updateProject'
    ]),

    /* Ordenar Tabla */
    async orderOnServer ({ column, order, prop }) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })
      try {
        let stringSort = ''
        const dataQuery = {
          query: {}
        }

        if (order === 'descending') {
          order = 'DESC'
        } else if (order === 'ascending') {
          order = 'ASC'
        } else {
          order = 'ASC'
        }

        if (!prop) {
          prop = 'creationDateTime'
        } else if (prop === 'isSender') {
          prop = 'sender'
        } else if (prop === 'isReceiver') {
          prop = 'receiver'
        }
        stringSort = prop + ',' + order
        this.queryServices.sort = stringSort
        await this.queryServicesState(this.queryServices)
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryServices.urlName = this.urlIn
        } else {
          this.queryServices.urlName = null
        }
        dataQuery.query = this.queryServices
        const response = await this.getServices(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Recoger Id de la Celda al hacer un click de raton */
    updateSender (row) {
      this.goUpdateProject(row)
      this.$notify({
        title: this.$t('msg_generics.alter_configuration'),
        type: 'warning',
        position: 'top-right',
        customClass: 'b2b-notification-success',
        duration: 10000
      })
    },

    updateReceiver (row) {
      this.goUpdateProject(row)
      this.$notify({
        title: this.$t('msg_generics.alter_configuration'),
        type: 'warning',
        position: 'top-right',
        customClass: 'b2b-notification-success',
        duration: 10000
      })
    },

    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    /* Ir al detalle */
    handleGoDetail (service) {
      this.selectService(service)
      sessionStorage.setItem('projectName', service.name)
      router.push({
        name: 'service-detail',
        params: {
          projectId: service.id,
          projectName: service.name
        }
      })
    },

    /** Guarda el cambio de estado de un proyecto(Habilitado/Deshabilitado) */
    async goUpdateStatusProject (row) {
      console.log('goUpdateStatusProject ...')
      try {
        const request = {
          projectId: row.id,
          enable: row.enable
        }
        await this.updateStatusProject(request)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    /** Actualiza el proyecto se utiliza para actualizar el emisor/receptor */
    async goUpdateProject (row) {
      console.log('goUpdateProject...')
      try {
        const request = {
          projectId: row.id,
          code: row.code,
          enable: row.enable,
          isIndraProject: row.isIndraProject,
          isReceiver: row.isReceiver,
          isSender: row.isSender,
          name: row.name,
          securityCode: row.securityCode
        }
        await this.updateProject(request)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuServicios />
    },

    /* Tamaño de la Tabla */
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      try {
        const dataQuery = {
          query: {}
        }
        this.queryServices.size = val
        await this.queryServicesState(this.queryServices)
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryServices.urlName = this.urlIn
        } else {
          this.queryServices.urlName = null
        }
        dataQuery.query = this.queryServices
        const response = await this.getServices(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Paginación */
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })
      try {
        const dataQuery = {
          query: {}
        }
        this.queryServices.page = val - 1
        await this.queryServicesState(this.queryServices)
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryServices.urlName = this.urlIn
        } else {
          this.queryServices.urlName = null
        }
        dataQuery.query = this.queryServices

        const response = await this.getServices(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      const dataQuery = {
        query: {}
      }

      this.options = filters.filters
      if (this.urlIn && this.urlIn !== 'b2b') {
        this.queryServices.urlName = this.urlIn
      } else {
        this.queryServices.urlName = null
      }
      dataQuery.query = this.queryServices
      const response = await this.getServices(dataQuery)
      this.totalResults = response.data.totalElements
      this.currentPage = response.data.number + 1
    } catch (error) {
      console.log('getUsers CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}

</script>

<style lang="scss" scoped>
.b2b-table-servicios {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}
</style>
